module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/credit-cards/mastercard-bde1e45b59004537f555779badf99d4a.jpg";